<template>
    <button type="button" class="btn-custom vs-component vs-button"
        :class="[`vs-button-${getColor()}`, `vs-button-${getType()}`]" style="background: transparent;" @click="$emit('click', $event)">
      <span class="btn-custom-bg" :class="[`bg-${getColor()}`]"></span>
      <span class="vs-button-text vs-button--text">
          <slot></slot>
      </span>
    </button>
</template>

<script>
export default {
    name: 'btn-custom',
    props: {
        color: {
            type: String,
            default: 'primary'
        },
        type: {
            type: String,
            default: 'border'
        }
    },
    data() {
        return {
            color_arr: ['primary', 'success', 'danger', 'warning', 'dark'],
            type_arr : ['border', 'filled']
        }
    },
    methods: {
        getColor() {
            if(this.color) {
                for(let i = 0; i < this.color_arr.length; i++) {
                    if(this.color_arr[i] == this.color.toLowerCase()) {
                        return this.color_arr[i];
                    }
                }
            }
            if(this.color == 'custom') {
                return this.color;
            }
            return 'primary';
        },
        getType() {
            if(this.type) {
                for(let i = 0; i < this.type_arr.length; i++) {
                    if(this.type_arr[i] == this.type.toLowerCase()) {
                        return this.type_arr[i];
                    }
                }
            }
            return 'border';
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/_variables";
@import "@/assets/scss/custom/_variables";
$color-arr: ('primary', 'success', 'danger', 'warning', 'dark');
    .btn-custom {
        position: relative;
        &.vs-button-custom {
            border: 1px solid #e5e5e5;
            background: transparent !important;
            color: #000;
        }
        .btn-custom-bg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 0;
            height: 0;
            // border-radius: 50%;
            // transition: all 0.1s ease;
            border-radius: 30%;
            transition: all 0.25s ease;

            @for $i from 0 to length($color-arr) {
                &.bg-#{unquote(nth($color-arr, $i+1))} {
                    background: unquote(nth($color-arr, $i+1));
                }
            }

            &.bg-custom {
                background: $primary;
            }
        }

        &.vs-button-filled {
            .btn-custom-bg {
                background: rgba(#fff, 0.3) !important;
            }
        }

        .vs-button--text {
            user-select: none;
            transition: all 0.1s ease;
        }

        &:active {
            // transform: scale(1.05);
            .btn-custom-bg {
                // animation: animationXYZ 0.7s linear;
                // width: 170%;
                // height: 170%;
                width: 1000px;
                height: 1000px;
            }
            .vs-button--text {
                color: #fff;
                font-weight: bold;
            }
        }
    }

    // @keyframes animationXYZ {
    //     0%, 100% {
    //         width: 0;
    //         height: 0;
    //     }
    //     50% {
    //         width: 500px;
    //         height: 500px;
    //     }
    // }
</style>